import React, { useState } from "react";
import CurrentDateAndTime from "../../atoms/CurrentDateAndTime/CurrentDateAndTime";
import YouTube from "react-youtube";
import DiagnosisText, {
  DisagnosisTextType,
} from "../DiagnosisText/DiagnosisText";
import { useTranslation } from "react-i18next";
import { getVideoTimeStamps } from "../../../services/helpers/constants";

interface EditModeDoctorsReportProps {
  warningText?: string;
  adviseText?: string;
  onDiagnosisTextChange?: (type: DisagnosisTextType, value: string) => void;
}

const EditModeDoctorsReport = (props: EditModeDoctorsReportProps) => {
  const { warningText, adviseText, onDiagnosisTextChange } = props;

  const { t } = useTranslation();

  const isTabletView = window.innerWidth < 1440;

  const [player, setPlayer] = useState<any | null>(null);

  const videoId = "alKO72Gn7M8";

  const onPlayerReady = (event: { target: any }) => {
    setPlayer(event.target);
  };

  const seekToTime = (time: number) => {
    if (player) {
      player.seekTo(time, true);
    }
  };

  const helpVideoTimeStamps = getVideoTimeStamps(t);

  return (
    <div
      className="dui-doctors-report dui-edit-mode-doctors-report"
      id="dui-doctors-report"
    >
      <h1 className="dui-doctors-report-edit-title">{t("editModeTutorial")}</h1>
      {!isTabletView && (
        <div className="dui-doctors-report-subtitle">
          <CurrentDateAndTime />
          <div className="dui-doctors-report-subtitle-actions">
            <DiagnosisText
              warningText={warningText}
              adviseText={adviseText}
              onTextChange={onDiagnosisTextChange}
            />
          </div>
        </div>
      )}

      <div className="dui-edit-mode-doctors-report-video">
        <YouTube
          videoId={videoId}
          onReady={onPlayerReady}
          className="dui-youtube-video"
        />
        <div className="dui-edit-mode-doctors-report-video-timestamps">
          {helpVideoTimeStamps.map((item) => (
            <div
              className="dui-timestamp"
              onClick={() => seekToTime(item.time)}
              key={item.time}
            >
              <span className="dui-edit-mode-report-timestamp-time">
                {item.displayTime}
              </span>{" "}
              - {item.description}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EditModeDoctorsReport;
